<template>
  <div v-if="editor" class="mb-1" id="lm-bubble-editor-text-menu">
    <div class="shadow rounded p-1 border border-light editor-menu">
      <MenuButton
        title="Encabezado 1"
        icon="format-header-1"
        @click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
        :class="{ 'is-active': editor.isActive('heading', { level: 1 }) }"
        :disableTooltip="true"
      />
      <MenuButton
        title="Encabezado 2"
        icon="format-header-2"
        @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
        :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }"
        :disableTooltip="true"
      />
      <MenuButton
        title="Encabezado 3"
        icon="format-header-3"
        @click="editor.chain().focus().toggleHeading({ level: 3 }).run()"
        :class="{ 'is-active': editor.isActive('heading', { level: 3 }) }"
        :disableTooltip="true"
      />
      <MenuButton
        title="Encabezado 4"
        icon="format-header-4"
        @click="editor.chain().focus().toggleHeading({ level: 4 }).run()"
        :class="{ 'is-active': editor.isActive('heading', { level: 4 }) }"
        :disableTooltip="true"
      />
      <MenuButton
        title="Izquierda"
        icon="format-align-left"
        @click="editor.chain().focus().setTextAlign('left').run()"
        :class="{ 'is-active': editor.isActive({ textAlign: 'left' }) }"
        :disableTooltip="true"
      />
      <MenuButton
        title="Centrado"
        icon="format-align-center"
        @click="editor.chain().focus().setTextAlign('center').run()"
        :class="{ 'is-active': editor.isActive({ textAlign: 'center' }) }"
        :disableTooltip="true"
      />
      <MenuButton
        title="Derecha"
        icon="format-align-right"
        @click="editor.chain().focus().setTextAlign('right').run()"
        :class="{ 'is-active': editor.isActive({ textAlign: 'right' }) }"
        :disableTooltip="true"
      />
      <MenuButton
        title="Justificado"
        icon="format-align-justify"
        @click="editor.chain().focus().setTextAlign('justify').run()"
        :class="{ 'is-active': editor.isActive({ textAlign: 'justify' }) }"
        :disableTooltip="true"
      />
      <MenuButton
        title="Párrafo"
        icon="format-paragraph"
        @click="editor.chain().focus().setParagraph().run()"
        :class="{ 'is-active': editor.isActive('paragraph') }"
        :disableTooltip="true"
      />
      <MenuButton
        title="Negrita"
        icon="format-bold"
        @click="editor.chain().focus().toggleBold().run()"
        :class="{ 'is-active': editor.isActive('bold') }"
        :disableTooltip="true"
      />
      <MenuButton
        title="Itálica"
        icon="format-italic"
        @click="editor.chain().focus().toggleItalic().run()"
        :class="{ 'is-active': editor.isActive('italic') }"
        :disableTooltip="true"
      />
      <MenuButton
        title="Subrayado"
        icon="format-underline"
        @click="editor.chain().focus().toggleUnderline().run()"
        :class="{ 'is-active': editor.isActive('underline') }"
      />
      <MenuButton
        title="Cita"
        icon="format-quote-close"
        @click="editor.chain().focus().toggleBlockquote().run()"
        :class="{ 'is-active': editor.isActive('blockquote') }"
        :disableTooltip="true"
      />
      <MenuButton
        title="Listado"
        icon="format-list-bulleted"
        @click="editor.chain().focus().toggleBulletList().run()"
        :class="{ 'is-active': editor.isActive('bulletList') }"
        :disableTooltip="true"
      />
      <MenuButton
        title="Listado Ordenado"
        icon="format-list-numbered"
        @click="editor.chain().focus().toggleOrderedList().run()"
        :class="{ 'is-active': editor.isActive('orderedList') }"
        :disableTooltip="true"
      />
      <MenuButton
        title="Línea Horizontal"
        icon="minus"
        @click="editor.chain().focus().setHorizontalRule().run()"
        :disableTooltip="true"
      />
      <MenuButton
        title="Deshacer"
        icon="undo-variant"
        @click="editor.chain().focus().undo().run()"
        :disabled="!editor.can().undo()"
        :disableTooltip="true"
      />
      <MenuButton
        title="Rehacer"
        icon="redo-variant"
        @click="editor.chain().focus().redo().run()"
        :disabled="!editor.can().redo()"
        :disableTooltip="true"
      />
      <MenuButton
        title="Identar menos"
        icon="format-indent-decrease"
        @click="editor.commands.outdent()"
      />
      <MenuButton
        title="Identar más"
        icon="format-indent-increase"
        @click="editor.commands.indent()"
      />
      <MenuButton
        v-if="hasVariables"
        title="Variables"
        icon="variable"
        @click="$emit('toggle-variables')"
        :disableTooltip="true"
      />
      <MenuButton
        title="Insertar Tabla"
        icon="table-large-plus"
        @click="editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run()"
        :disableTooltip="true"
      />
      <MenuButton
        title="Eliminar Tabla"
        icon="table-large-remove"
        @click="editor.chain().focus().deleteTable().run()"
        :disabled="!editor.can().deleteTable()"
        :disableTooltip="true"
      />
      <MenuButton
        title="Agregar Columna Izquierda"
        icon="table-column-plus-before"
        @click="editor.chain().focus().addColumnBefore().run()"
        :disabled="!editor.can().addColumnBefore()"
        :disableTooltip="true"
      />
      <MenuButton
        title="Agregar Columna Derecha"
        icon="table-column-plus-after"
        @click="editor.chain().focus().addColumnAfter().run()"
        :disabled="!editor.can().addColumnAfter()"
        :disableTooltip="true"
      />
      <MenuButton
        title="Eliminar Columna"
        icon="table-column-remove"
        @click="editor.chain().focus().deleteColumn().run()"
        :disabled="!editor.can().deleteColumn()"
        :disableTooltip="true"
      />
      <MenuButton
        title="Agregar Fila Arriba"
        icon="table-row-plus-before"
        @click="editor.chain().focus().addRowBefore().run()"
        :disabled="!editor.can().addRowBefore()"
        :disableTooltip="true"
      />
      <MenuButton
        title="Agregar Fila Abajo"
        icon="table-row-plus-after"
        @click="editor.chain().focus().addRowAfter().run()"
        :disabled="!editor.can().addRowAfter()"
        :disableTooltip="true"
      />
      <MenuButton
        title="Borrar Fila"
        icon="table-row-remove"
        @click="editor.chain().focus().deleteRow().run()"
        :disabled="!editor.can().deleteRow()"
        :disableTooltip="true"
      />
      <MenuButton
        title="Combinar o Separar Columnas"
        icon="table-merge-cells"
        @click="editor.chain().focus().mergeOrSplit().run()"
        :disabled="!editor.can().mergeOrSplit()"
        :disableTooltip="true"
      />
      <MenuButton
        title="Convertir en Encabezado"
        icon="table-border"
        @click="editor.chain().focus().toggleHeaderCell().run()"
        :disabled="!editor.can().toggleHeaderCell()"
        :disableTooltip="true"
      />
    </div>
  </div>
</template>

<script>
import MenuButton from './MenuButton'
import TableMenu from './TableMenu'

export default {
  props: {
    editor: Object,
    hasVariables: Boolean
  },
  components: {
    MenuButton,
    TableMenu
  }
}
</script>

<style lang="sass">
#lm-editor-text-menu
  .is-active
    background-color: #dbdbdb
#lm-bubble-editor-text-menu
  .editor-menu
    display: grid
    grid-template-columns: repeat(16, minmax(21px, 1fr)); /* Cambio a dos columnas */
    grid-column-gap: 2px
</style>
